/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Listings_EmptyInputs */

const en_seller_listings_empty = /** @type {(inputs: Seller_Listings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No listings yet.`)
};

const es_seller_listings_empty = /** @type {(inputs: Seller_Listings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay anuncios.`)
};

const fr_seller_listings_empty = /** @type {(inputs: Seller_Listings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune annonce pour le moment.`)
};

const de_seller_listings_empty = /** @type {(inputs: Seller_Listings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Inserate.`)
};

const ja_seller_listings_empty = /** @type {(inputs: Seller_Listings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ出品がありません。`)
};

const zh_seller_listings_empty = /** @type {(inputs: Seller_Listings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无商品。`)
};

const ar_seller_listings_empty = /** @type {(inputs: Seller_Listings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد إعلانات بعد.`)
};

const id_seller_listings_empty = /** @type {(inputs: Seller_Listings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada listing.`)
};

const it_seller_listings_empty = /** @type {(inputs: Seller_Listings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun annuncio.`)
};

const ru_seller_listings_empty = /** @type {(inputs: Seller_Listings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока нет объявлений.`)
};

const pt_seller_listings_empty = /** @type {(inputs: Seller_Listings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum anúncio ainda.`)
};

const ko_seller_listings_empty = /** @type {(inputs: Seller_Listings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 등록된 상품이 없습니다.`)
};

/**
* | output |
* | --- |
* | "No listings yet." |
*
* @param {Seller_Listings_EmptyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_listings_empty = /** @type {((inputs?: Seller_Listings_EmptyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Listings_EmptyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_listings_empty(inputs)
	if (locale === "es") return es_seller_listings_empty(inputs)
	if (locale === "fr") return fr_seller_listings_empty(inputs)
	if (locale === "de") return de_seller_listings_empty(inputs)
	if (locale === "ja") return ja_seller_listings_empty(inputs)
	if (locale === "zh") return zh_seller_listings_empty(inputs)
	if (locale === "ar") return ar_seller_listings_empty(inputs)
	if (locale === "id") return id_seller_listings_empty(inputs)
	if (locale === "it") return it_seller_listings_empty(inputs)
	if (locale === "ru") return ru_seller_listings_empty(inputs)
	if (locale === "pt") return pt_seller_listings_empty(inputs)
	return ko_seller_listings_empty(inputs)
});